import { NgModule } from '@angular/core';
import { ConfigAlertComponent } from './config-alert/config-alert.component';
import { TranslateModule } from '@ngx-translate/core';
import { ConfigsRoutingModule } from './configs-routing.module';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [
    ConfigAlertComponent
  ],
  imports: [
    TranslateModule,
    ConfigsRoutingModule,
    SharedModule
  ],
  exports: [ConfigAlertComponent]
})
export class ConfigsModule {
}
